import { AccessTokenValue } from '../auth/auth.types';
import { request } from '../utils/request';

export const toggleWishList = async (isFavorite: boolean, url: string, accessToken: AccessTokenValue) => {
  await request({ url, method: isFavorite ? 'POST' : 'DELETE' }, accessToken);
};
